"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GridDataSourceCacheDefault = void 0;
exports.getKey = getKey;
function getKey(params) {
    return JSON.stringify([
        params.paginationModel,
        params.filterModel,
        params.sortModel,
        params.groupKeys,
        params.groupFields
    ]);
}
var GridDataSourceCacheDefault = /*#__PURE__*/ function() {
    function GridDataSourceCacheDefault(param) {
        var _param_ttl = param.ttl, ttl = _param_ttl === void 0 ? 300000 : _param_ttl;
        _class_call_check(this, GridDataSourceCacheDefault);
        this.cache = void 0;
        this.ttl = void 0;
        this.cache = {};
        this.ttl = ttl;
    }
    _create_class(GridDataSourceCacheDefault, [
        {
            key: "set",
            value: function set(key, value) {
                var keyString = getKey(key);
                var expiry = Date.now() + this.ttl;
                this.cache[keyString] = {
                    value: value,
                    expiry: expiry
                };
            }
        },
        {
            key: "get",
            value: function get(key) {
                var keyString = getKey(key);
                var entry = this.cache[keyString];
                if (!entry) {
                    return undefined;
                }
                if (Date.now() > entry.expiry) {
                    delete this.cache[keyString];
                    return undefined;
                }
                return entry.value;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.cache = {};
            }
        }
    ]);
    return GridDataSourceCacheDefault;
}();
exports.GridDataSourceCacheDefault = GridDataSourceCacheDefault;
